export default {
  jp: {
    title: {
      maintenance: '只今メンテナンス中です。'
    },
    label: {
    },
    ph: {
    },
    button: {
    },
    desc: {
      errorDesc: '入力エラーがあります。',
      authErrorDesc: 'セッションタイムアウトが発生しました。再度ログインから実行してください。',
      systemErrorDesc: 'サーバーエラーが発生しました。再度時間をおいてアクセスしてください。',
      maintenance: '申し訳ありませんが、暫くしてから再度アクセスをお願いします。'
    }
  },
  en: {
    title: {
      maintenance: 'Now under maintenance.'
    },
    label: {
    },
    ph: {
    },
    button: {
    },
    desc: {
      errorDesc: 'Input error.',
      authErrorDesc: 'Session timeout. Please log in again.',
      systemErrorDesc: 'A server error has occurred. Please take the time to access again.',
      maintenance: 'Please try again in a little while.'
    }
  }
}
